import React from "react";
import ClubsForm from "./ClubsForm";
import CustomCard from "../../../shared/Card/CustomCard";

const EditClubs = ({ name }) => {
    return (
        <CustomCard title={name}>
            <ClubsForm type="EDIT" />
        </CustomCard>
    );
};

export default EditClubs;
